import styled from 'styled-components';

const SmallHeader = styled.h3`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  line-height: 20px;
  margin-top: 24px;
  color: #00144d;
`;

export default SmallHeader;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/components/SmallHeader.tsx